<script>
    import { duplicateIcon } from "../../../Utils/utilConstants.svelte";

    import { copyObjContent } from "../../../Utils/utilFunctions.svelte";

    import { CardLayout } from "../index.svelte";

    export let reason = "";

    let isReasonInJson;

    if (reason) {
        try {
            JSON.parse(reason);
            isReasonInJson = true;
        } catch (err) {
            isReasonInJson = false;
        }
    }

    $: btnOptions = [
        {
            iconName: "copyIcon",
            iFont: duplicateIcon,
            hasTooltip: true,
            tooltip: "Copy content",
            iconFunction: () =>
                copyObjContent(
                    isReasonInJson ? JSON.parse(reason) : reason,
                    "Reason Copied!",
                ),
            isHidden: !reason,
        },
    ];
</script>

<CardLayout title="Reason" {btnOptions}>
    <div class="flex flex-col p-2 w-full gap-y-3">
        <div class="flex flex-row gap-x-2">
            {#if reason}
                {#if isReasonInJson}
                    <pre
                        class="whitespace-pre-wrap font-sans break-words">{JSON.stringify(
                            JSON.parse(reason),
                            undefined,
                            2,
                        )}</pre>
                {:else}
                    <p class="whitespace-pre-wrap break-all font-sans">
                        {reason}
                    </p>
                {/if}
            {:else}
                <p>No reason</p>
            {/if}
        </div>
    </div>
</CardLayout>
